import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

import jsQR from "jsqr";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { getUserData } from "../../../utils/localStorage";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { postBrandStoreUpiConfig } from "../../../services/StoreUsers/PostStoreUsers";
import { Checkbox } from "primereact/checkbox";
import { BRAND_BASE_URL } from "../../../services/BaseURL";
import { useEffect } from "react";

const UPIDisclaimer = () => {
  const navigate = useNavigate();

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;

  const location = useLocation();
  const { id, storeInfoData } = location.state || {}; // Fallback to prevent undefined errors

  const [paymentQrCodeError, setPaymentQrCodeError] = useState("");
  const [isButtonPressed, setIsButtonPressed] = useState(false);

  const [input, setInput] = useState({
    upiAccountId: "",
    upiAccountName: "",
    upiAccountLink: "",
  });

  useEffect(() => {
    setInput((prevState) => ({
      ...prevState,

      upiAccountId: storeInfoData?.upiAccountId || "",
      upiAccountName: storeInfoData?.upiAccountName || "",
      upiAccountLink: storeInfoData?.upiAccountLink || "",
    }));
  }, [storeInfoData]);

  const [checked, setChecked] = useState("");

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const image = new Image();
        image.src = e.target.result;
        image.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0, image.width, image.height);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const qrCode = jsQR(
            imageData.data,
            imageData.width,
            imageData.height,
          );

          if (qrCode) {
            const queryString = qrCode.data.split("?")[1]; // Get the part after '?'
            if (!queryString) {
              setPaymentQrCodeError(
                "Invalid Upi Qr Code Please Go Back And Come Again",
              );
              return;
            }

            // Manually parse query parameters
            const params = {};
            queryString.split("&").forEach((param) => {
              const [key, value] = param.split("=");
              params[key] = decodeURIComponent(value || "");
            });

            const upiData = {
              upiId: params.pa || "",
              upiUserName: params.pn || "",
            };

            setInput({
              ...input,
              upiAccountName: upiData.upiUserName,
              upiAccountId: upiData.upiId,
            });
          } else {
            setPaymentQrCodeError(
              "No Qr Code Found In Image Or Qr Code Image is Clear",
            );
          }
        };
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = () => {
    let isValid = true;

    if (isValid) {
      // Logic for creating a new pickup request
      if (!isButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsButtonPressed(true);

        const data = {
          ...input,
          brandId: brandId,
          id: storeInfoData?.id,
        };

        // Call the service function for creating pickup request

        // if (!isUpdating) {
        postBrandStoreUpiConfig(brandId, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  successMessage(message);
                  setTimeout(() => {
                    navigate("/store-management-list", {
                      state: brandId,
                    });
                  }, 1500);
                  setIsButtonPressed(false);
                } else {
                  errorMessage(message);
                  setIsButtonPressed(false);
                }
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
        // } else {
        //   updateBrandStore(brandId.id, UpdateData)
        //     .then((response) => {
        //       if (!response.data.error) {
        //         const Res = response.data;
        //         if (Res) {
        //           const message = Res.message;
        //           const status = Res.status;
        //           // sendResponse({message, status, modalFun: false});
        //           // Reset state variables
        //           if (status === true) {
        //            successMessage(message);
        //             setTimeout(() => {
        //               navigate("/store-management-list", {
        //               state: brandId,
        //             })
        //             }, 1500);
        //             setIsButtonPressed(false);
        //           } else {
        //             errorMessage(message)
        //             setIsButtonPressed(false);
        //           }
        //         }
        //       }
        //     })
        //     .catch((err) => {
        //       console.error("Error:", err);
        //     });
        // }
      }
    } else {
      setIsButtonPressed(false);
    }
  };

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreManagementCreate", {
                      state: {
                        id: id,
                        upiData: null,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                UPI ID Disclaimer
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="mx-4">
          <div
            className="flex-1 shadow-2 p-2 border-2 border-round-xl cursor-pointer"
            style={{ borderColor: "#fff", backgroundColor: "#fff" }}
          >
            <p className="text-3xl font-bold text-justify">
              Disclaimer for UPI ID Storage & Liability
            </p>
            <p className="text-lg font-normal text-justify my-4">
              Dhobi Cart collects and stores UPI IDs solely for facilitating
              transactions. However, we do not guarantee the accuracy, security,
              or uninterrupted availability of UPI-based transactions.
            </p>
            <p className="text-lg font-normal text-justify my-4">
              The UPI ID entered in the application is solely the responsibility
              of the admin of the brand, and Dhobi Cart is not responsible for
              any transactions made through the QR code generated using the
              provided UPI ID. Any loss, unauthorized access, misuse, fraud, or
              disputes related to transactions must be addressed directly with
              the respective bank or payment service provider.
            </p>
            <p className="text-lg font-normal text-justify my-4">
              Dhobi Cart does not store sensitive financial details such as
              OTPs, PINs, or passwords. Users are responsible for ensuring the
              security of their payment credentials and transactions.
            </p>
          </div>
          {/* 
          <div
            className="flex-1 shadow-2 p-2 my-3 border-2 border-round-xl cursor-pointer"
            style={{ borderColor: "#fff", backgroundColor: "#fff" }}
          >
            <h2>Upload Your Payment QrCode Image Below</h2>
            <input type="file" accept="image/*" onChange={handleImageUpload} />
            {paymentQrCodeError && <p className="text-xl font-normal" style={{color:"red"}}>{paymentQrCodeError}</p>}
          </div> */}

          <div className="flex flex-1 my-3 gap-3">
            <div className="mt-4  flex-1">
              <FloatLabel>
                <InputText
                  id="upiAccountName"
                  value={input.upiAccountName}
                  onChange={(e) => {
                    setInput({
                      ...input,
                      upiAccountName: e.target.value,
                    });
                  }}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                />
                <label
                  htmlFor="upiAccountName"
                  className="text-lg"
                  style={{ color: "blue" }}
                >
                  Upi Account Name
                </label>
              </FloatLabel>
            </div>
            <div className="mt-4  flex-1 ">
              <FloatLabel>
                <InputText
                  id="upiAccountId"
                  value={input.upiAccountId}
                  onChange={(e) => {
                    setInput({
                      ...input,
                      upiAccountId: e.target.value,
                    });
                  }}
                  // disabled={true}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                />
                <label
                  htmlFor="upiAccountId"
                  className="text-lg"
                  style={{ color: "blue" }}
                >
                  Upi Account Id
                </label>
              </FloatLabel>
            </div>
          </div>
          <div className="flex flex-1 mb-3">
            <div className=" mt-4  flex-1">
              <label
                htmlFor="upiAccountLink"
                className="text-lg"
                style={{ color: "blue", marginRight: 10 }}
              >
                Set Default Upi Account Link
              </label>
              <Checkbox
                size={20}
                checked={checked}
                color={checked ? "#00A3FF" : "#C1C9D3"}
                onClick={() => {
                  setChecked((prevChecked) => {
                    const newChecked = !prevChecked;

                    setInput((prevInput) => ({
                      ...prevInput,
                      upiAccountLink: newChecked
                        ? `upi://pay?pa=${prevInput?.upiAccountId}&pn=${prevInput?.upiAccountName}&am=@@AMOUNT@@&tn=@@ORDERID@@`
                        : storeInfoData?.upiAccountLink,
                    }));

                    return newChecked;
                  });
                }}
              />
            </div>
          </div>
          <div className="flex flex-1 mb-3">
            <div className=" mt-4  flex-1">
              <FloatLabel>
                <InputText
                  id="upiAccountLink"
                  value={input.upiAccountLink}
                  onChange={(e) => {
                    setInput({
                      ...input,
                      upiAccountLink: e.target.value,
                    });
                  }}
                  className="w-full text-xl p-2 border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                />
                <label
                  htmlFor="upiAccountLink"
                  className="text-lg"
                  style={{ color: "blue" }}
                >
                  Upi Account Link
                </label>
              </FloatLabel>
            </div>
          </div>
          <div
            className="flex-1 shadow-2 p-2 my-4 border-2 border-round-xl cursor-pointer"
            style={{ borderColor: "#fff", backgroundColor: "#fff" }}
          >
            <div className="flex flex-row justify-content-between">
              <h2>Upload Your Payment QrCode Image Below</h2>
              <div className="flex flex-row-reverse ">
                <img
                  src={
                    BRAND_BASE_URL +
                    `/store/api/secure/v1/qr-code/store-upi-qr/${storeInfoData.id}/500/500`
                  }
                  alt="banner"
                  style={{ width: 100 }}
                />
              </div>
            </div>
            <input type="file" accept="image/*" onChange={handleImageUpload} />
            {paymentQrCodeError && (
              <p className="text-xl font-normal m-0" style={{ color: "red" }}>
                {paymentQrCodeError}
              </p>
            )}
          </div>

          <div className="flex ">
            <Button
              className="mt-1 mb-3  border-round-xl w-full"
              onClick={handleSubmit}
              disabled={isButtonPressed}
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center m-0">
                Submit
              </p>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UPIDisclaimer;
